import { cols } from "@/config/system";

export const tableColumn = (props: any, selectData: any) => [
  ...props.isDialog ? [
    {
      type: "selection",
      selectable: (row: any, index: boolean) => {
        return props.multiSelect || (selectData.value.length == 0 ||  selectData.value[0].id == row.id)
      }
    }
  ] : [],
  {
    type: "index",
    label: "序号",
    disabled: true,
    width: cols.number
  },
  {
    label: "姓名",
    prop: "customerName",
  },
  {
    label: "电话",
    prop: "customerPhone",
  },
  {
    label: "省市区",
    prop: "province",
    formatter: (row: any) => {
      return (row.province || '') + (row.city || '') + (row.area || '');
    },
  },
  {
    label: "详细地址",
    prop: "detailsAddress",
  },
  {
    label: "操作",
    prop: "actions",
    width: cols.bigMedium,
    slotName: 'actions'
  },
];
